<template>
  <div>
    <!-- 레이어 팝업 -->
    <download-popup v-if="downloadLayout" :contenttype="type" :contentInfo="contentInfo"
                    :contentid="contentid" :close="closeDownloadLayout"/>
    <PopupShare v-if="shareLayout"
                :close="closeShareLayout"
                :title="contentInfo.programtitle"
                :description="contentInfo.episodenumber +'회 '+contentInfo.episodetitle"
                :image="contentInfo.image"/>
    <!-- 콘텐츠 영역 -->
    <div class="vod player-wrap" id="g-contents">
      <!-- 플레이어 영역 -->
      <vod-player v-if="get(contentInfo, 'contentid', '') !== ''"
                  :content-info="contentInfo"
                  :is-play-ad="isPlayAd"
                  :key="'vodplayer'"
                  :open-download-popup="openDownloadPopup"
                  :open-share-popup="openShareLayout"
      />
      <!-- 플레이어 하단 메뉴 영역 -->
      <div class="player-nav">
        <ul>
          <li>
            <a :class="currentTabIs('all') ? 'on' : ''" @click.prevent="changeTab('all')">에피소드</a>
           </li>
          <li>
            <a :class="currentTabIs('recommend') ? 'on' : ''" @click.prevent="changeTab('recommend')">추천</a>
          </li>
        </ul>
      </div>
      <!-- 플레이어 하단 리스트 영역 -->
      <vod-all-list v-if="!isLoading && currentTabIs('all')" :content-info="contentInfo" :order="order" :key="'vod-all-list' + componentKey"/>
      <vod-multi-sections v-if="currentTabIs('recommend')" :content-info="contentInfo"
                          :key="'vod-multi-section-list' + componentKey"/>
    </div>
    <MetaInfo :content-info="contentInfo" content-type="vod"></MetaInfo>
  </div>
</template>

<script>
import VodMultiSections from '@/components/player/VodMultiSections'
import Swiper from '@/mixins/swiper'
import DownloadPopup from '@/components/player/PopupDownload'
import PopupShare from '@/components/player/PopupShare'
import VodAllList from '@/components/player/VodAllList'
import VodPlayer from '@/components/player/VodPlayer'
import MetaInfo from '@/components/meta/Meta'
import {
  addPostfixAndUrl, contentDetailErrorCatcher, destroyPlayer,
  doActionAdultVerification,
  isAdultContent,
  redirectToHttps,
  scrollTop, scrollTopWithCallback, unloadPlayer
} from '@/common/utils/common'
import { getVodContentsDetail, getVodProgramsContentid } from '@/common/utils/request'
import cookie from '@/common/utils/cookie'
import _ from 'lodash'
import {
  setPlayerModeDefault,
  showDownloadLayoutWithContext,
  showLoginPopup,
  showVoucherPopupWithContext
} from '@/common/utils/scalable.player'
import { mapMutations } from 'vuex'
import {
  DOMAIN,
  SET_CURRENT_MENU,
  MENU,
  GENRE_CODE_GLOBAL_DRAMA,
  UPDATE_CONTENT_INFO_EVENT
} from '@/common/resources/const'
import { parseUrl, stringify } from 'query-string'
import { getReferer, setReferer } from '@/common/utils/referer'
import playerPage from '@/mixins/player.page.mixin'
import { autoLoginSetting } from '@/common/utils/login'
export default {
  mixins: [
    Swiper,
    playerPage
  ],
  components: {
    VodMultiSections,
    DownloadPopup,
    PopupShare,
    VodAllList,
    VodPlayer,
    MetaInfo
  },
  data () {
    return {
      isLoading: true,
      componentKey: 0,
      playerUpdateKey: 0,
      tabType: 'all',
      type: 'vod',
      contentid: '',
      programid: '',
      contentInfo: {}, // 콘텐츠 데이터
      order: 'new'
    }
  },
  methods: {
    ...mapMutations([SET_CURRENT_MENU]),
    get: _.get,
    setActiveGnbMenuByContentGenre (genreCode) {
      if (genreCode === GENRE_CODE_GLOBAL_DRAMA) {
        this[SET_CURRENT_MENU](MENU.GLOBAL)
      } else {
        this[SET_CURRENT_MENU](MENU.BROADCAST)
      }
    },
    isThisAdultContentThenGoVerifyPage (targetAge) {
      if ((isAdultContent(targetAge) && cookie.isNotVerifiedAdultUser())) {
        doActionAdultVerification({ referer: getReferer(), enter: this.$route.fullPath })
      }
    },
    currentTabIs (tabType) {
      return this.tabType === tabType
    },
    changeTab (tabType) {
      this.componentKey += 1
      this.tabType = tabType
    },
    setData () {
      this.isLoading = true
      getVodContentsDetail({ contentid: this.contentid }).then(({ data }) => {
        this.setActiveGnbMenuByContentGenre(_.get(data, 'genrevalue', ''))
        this.isThisAdultContentThenGoVerifyPage(_.get(data, 'targetage', '0'))
        this.contentInfo = data
        if (_.get(this.$route, 'query.order', '') === '') {
          this.updateOrder(_.get(data, 'episodeorder', 'new'))
        }
        if (!this.programid) { this.programid = this.contentInfo.programid }
        this.setMetaData({
          ogTitle: _.get(data, 'programtitle', ''),
          ogDescription: _.get(data, 'episodenumber', '') + '회 ',
          ogImage: addPostfixAndUrl(_.get(data, 'image', ''), '4')
        })
        this.isLoading = false
        scrollTopWithCallback(setPlayerModeDefault)
        this.setPlayerEvent()
      }).catch(contentDetailErrorCatcher.bind(this))
    },
    setPlayerEvent () {
      window.showLoginLayout = showLoginPopup
      window.showDownloadLayout = showDownloadLayoutWithContext(this) // download 레이어팝업
      window.showVoucherPopup = showVoucherPopupWithContext({ type: this.type, contentInfo: this.contentInfo }) // 이용권 팝업
      window.showEventVoucherPopup = () => { window.open('/voucher/popup?type=all', '', 'width=700, height=780, scrollbars=yes') } // 이벤트 이용권 팝업
      window.isVerifiedAdultUser = cookie.isVerifiedAdultUser.bind(cookie)
    },
    getContentIdFromProgramId (programId) {
      return getVodProgramsContentid({ programid: programId }).catch(contentDetailErrorCatcher.bind(this))
    },
    setDataWithIds () {
      if (this.contentid === '' && this.programid !== '') {
        this.getContentIdFromProgramId(this.programid).then(({ data }) => {
          this.contentid = data.contentid
          this.setData()
        }).catch(contentDetailErrorCatcher.bind(this))
      } else {
        this.setData()
      }
    },
    initialize () {
      const { query } = parseUrl(location.href)
      this.programid = _.get(query, 'programid', '')
      this.contentid = _.get(query, 'contentid', '')
      this.order = _.get(this.$route, 'query.order', 'new')
      this.tabType = 'all'
      this.setDataWithIds()
    },
    updateContentInfo (info) {
      getVodContentsDetail({ contentid: _.get(info, 'contentID', '') }).then(({ data }) => {
        this.programid = _.get(info, 'programID', '')
        this.contentid = _.get(info, 'contentID', '')
        const onair = _.get(data, 'type', '') === 'onair' ? 'y' : 'n'
        const { query } = parseUrl(location.href)
        const pageNum = info.resetPage ? '1' : _.get(query, 'page', '1')
        const newQuery = { contentid: this.contentid, programid: this.programid, page: pageNum, onair: onair }
        this.replaceState(`vod?${stringify(newQuery)}`)
      })
    },
    updateOrder (order) {
      this.order = order
    }
  },
  created () {
    document.domain = DOMAIN
    window.voucherAutoLogin = function () {
      const credential = cookie.getCredential()
      const isMultiLine = Number(cookie.userInfo('profilecount')) !== 1
      autoLoginSetting(credential, isMultiLine).then(() => {
        location.reload()
      })
    }
    scrollTop()
    redirectToHttps()
    this.initialize()
  },
  mounted () {
    this.$events.$on(UPDATE_CONTENT_INFO_EVENT, (value) => {
      const updateContentId = _.get(value, 'contentID', '')
      const sameContentId = this.contentid === updateContentId
      console.log(`%c sameContentId : ${sameContentId}`, `background: #222; color:red;font-size: 15px`)// console.log(`%c sameProgramId : ${sameProgramId}`, `background: #222; color:red;font-size: 15px`)
      if (sameContentId) return
      this.updateContentInfo(value)
    })
  },
  beforeDestroy () {
    this.$events.$off(UPDATE_CONTENT_INFO_EVENT)
    destroyPlayer()
  },
  watch: {
    $route (n, o) {
      setReferer(o.fullPath)
      this.initialize()
      const newContentId = _.get(n, ['query', 'contentid'], '')
      const oldContentId = _.get(o, ['query', 'contentid'], '')
      const isOnAir = _.get(n, ['query', 'onair'], 'n') === 'y'
      if (newContentId === '') {
        this.programid = _.get(n, ['query', 'programid'], '')
        this.contentid = ''
        this.setDataWithIds()
        this.getContentIdFromProgramId(this.programid).then(({ data }) => {
          getVodContentsDetail({ contentid: _.get(data, 'contentid', '') }).then((contentMetaInfo) => {
            const meta = contentMetaInfo.data
            const vodType = _.get(meta, 'type', 'genenral') === 'onair' ? 'onairvod' : 'vod'
            window.playerInstance.load(vodType, _.get(meta, 'contentid', ''))
          })
        }).catch(contentDetailErrorCatcher.bind(this))
      } else if (newContentId !== oldContentId) {
        const vodType = isOnAir ? 'onairvod' : 'vod'
        window.playerInstance.load(vodType, newContentId)
      }
    }
  }
}
</script>
<style lang="css" src="@/assets/css/main.css"></style>
<style lang="css" src="@/assets/css/vod.css"></style>
